var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import deleteAssetRemark from '../../requests/asset/deleteAssetRemark';
/**
 *
 */
var DeleteAssetRemarkCommand = /** @class */ (function (_super) {
    __extends(DeleteAssetRemarkCommand, _super);
    function DeleteAssetRemarkCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param assetModel AssetModel
     * @param organisationId string
     * @param intl
     * @return {*}
     */
    DeleteAssetRemarkCommand.prototype.execute = function (assetModel, organisationId, intl) {
        var promise = deleteAssetRemark(organisationId, assetModel.getMetricsDbId());
        this.intl = intl;
        this.assetModel = assetModel;
        promise.then(this.then);
        return promise;
    };
    /**
    *
    * @param response
    */
    DeleteAssetRemarkCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.asset.updated' }, Object(this.assetModel.properties)), 'dark', true);
    };
    return DeleteAssetRemarkCommand;
}(Command));
export default DeleteAssetRemarkCommand;
